import { Component } from '@angular/core';

@Component({
  selector: 'sp-join-main',
  templateUrl: './join-main.component.html',
  standalone: false
})
export class JoinMainComponent {

}
